<script lang="ts">
    import { appManager } from "../../AppManagerStore";
    import Flickity from "flickity";
    import "../../../node_modules/flickity/dist/flickity.min.css";
    import type { Post } from "../Post";
    import type { Author } from "../Author";
    import type { Posts } from "../Posts";
    import type { Authors } from "../Authors";
    import BlogCarouselPost from "./BlogCarouselPost.svelte";
    import { _ } from "svelte-i18n";

    let container: HTMLDivElement;
    let flkty: Flickity;
    let posts: Post[] = [];
    let authors: Author[] = [];

    $: if (typeof container !== "undefined" && posts.length > 0) {
        flkty = new Flickity(container, {
            cellAlign: "left",
            contain: true,
            wrapAround: true,
        });
    }

    async function load(): Promise<boolean> {
        const response = await fetch(`${$appManager.PublicUrl}data/blog/posts.json`);
        const postsJson = (await response.json()) as Posts;

        posts = postsJson.posts;

        posts.sort((x, y) => {
            if (x.promoted != y.promoted) {
                if (x.promoted) return -1;
                return 1;
            }
            return -x.date.localeCompare(y.date);
        });

        posts = posts.filter((x) => x.frontpage);

        const authorsResponse = await fetch(
            `${$appManager.PublicUrl}data/blog/authors.json`
        );
        const authorsJson = (await authorsResponse.json()) as Authors;

        authors = authorsJson.authors;

        return true;
    }

    function getAuthor(post: Post): Author {
        const result = authors.find((x) => x.id == post.author);
        return result;
    }
</script>

{#await load()}
    <div />
{/await}

<section class="py-8 py-md-11 bg-gray-200">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-8 text-center">
                <h2>
                    {$_("home.blog.readmore1")}
                    <a href="{$appManager.PublicUrl}blog"
                        >{$_("home.blog.readmore2")}</a
                    >.
                </h2>

                <p class="fs-lg text-muted mb-7 mb-md-9">
                    {$_("home.blog.tagline")}
                </p>
            </div>
        </div>

        {#if authors.length > 0}
            <div
                class="carousel-container shadow-extra-dark-lg"
                bind:this={container}>
                {#each posts as post, i}
                    <BlogCarouselPost {post} author={getAuthor(post)} />
                {/each}
            </div>
        {/if}
    </div>
</section>

<style>
    .shadow-extra-dark-lg {
        box-shadow: 0 1.5rem 4rem rgba(22, 28, 45, 0.5) !important;
    }

    .carousel-container {
        width: 100%;
        border-radius: 0.375rem;
    }
</style>
